module.exports = __webpack_public_path__ + "static/media/image12.c541c6e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Nvidia/image12.png
// module id = 1178
// module chunks = 0